__turbopack_context__.v({
  "card": "ChoiceWithIcon-module-scss-module__Ap62pG__card",
  "description": "ChoiceWithIcon-module-scss-module__Ap62pG__description",
  "disabled": "ChoiceWithIcon-module-scss-module__Ap62pG__disabled",
  "icon": "ChoiceWithIcon-module-scss-module__Ap62pG__icon",
  "title": "ChoiceWithIcon-module-scss-module__Ap62pG__title",
});
